import { saveAs } from "file-saver";
import { QueryList } from "./Helpers";

export const exportExcel = (data, fromScreen) => {
  const tempData = [];
  let tempHeader = "";
  switch (fromScreen) {
    case QueryList.TRCRDaily:
      tempHeader = "Judge,Room,Date,Time,Case,Name,Voilation,Agency,Attorney,Prosecutor,Status\n";
      tempData.push(tempHeader);
      data?.forEach((eachResult) => {
        tempData.push(
          `${eachResult.JUDGE},${eachResult.ROOM},${eachResult.DATE},${eachResult.TIME},${eachResult.CASE},${eachResult.NAME.replace(/,/g, "")},${eachResult.VIOLATIONS},${eachResult.AGENCY},${
            eachResult.ATTORNEY
          },${eachResult.PROSECUTOR},${eachResult.STATUS}\n`
        );
      });
      break;
    case QueryList.TRCRArraignment:
      tempHeader = "Judge,Room,Date,Time,Case,Name,Voilation,Agency\n";
      tempData.push(tempHeader);
      data?.forEach((eachResult) => {
        tempData.push(
          `${eachResult.JUDGE},${eachResult.ROOM},${eachResult.DATE},${eachResult.TIME},${eachResult.CASE},${eachResult.NAME.replace(/,/g, "")},${eachResult.VIOLATIONS},${eachResult.AGENCY}\n`
        );
      });
      break;
    case QueryList.TRCRAttorney:
      tempHeader = "Attorney,Date,Time,Case,Name,Voilation,Status\n";
      tempData.push(tempHeader);
      data?.forEach((eachResult) => {
        tempData.push(`${eachResult.ATTORNEY},${eachResult.DATE},${eachResult.TIME},${eachResult.CASE},${eachResult.NAME.replace(/,/g, "")},${eachResult.VIOLATIONS},${eachResult.STATUS}\n`);
      });
      break;
    case QueryList.TRCRAgency:
      tempHeader = "Officer,Agency,Date,Time,Case,Voilation\n";
      tempData.push(tempHeader);
      data.forEach((eachResult) => {
        tempData.push(`${eachResult.OFFICER},${eachResult.Agency},${eachResult.DATE},${eachResult.TIME},${eachResult.CASE},${eachResult.VIOLATIONS}\n`);
      });
      break;
    case QueryList.CivilDaily:
      tempHeader = "JudgeName,CaseNumber,Plaintiff,Status,Defendant\n";
      tempData.push(tempHeader);
      data?.forEach((eachResult) => {
        tempData.push(
          `${eachResult.JudgeName},${eachResult.CaseNumber},${eachResult.PlaintiffList.replace(/<br \/>/g, " ")},${eachResult.Description},${eachResult.DefendantList.replace(/<br \/>/g, " ")}\n`
        );
      });
      break;
    case QueryList.CivilAttorney:
      tempHeader = "Attorney,Case,Plantiffs,Status,Defendant\n";
      tempData.push(tempHeader);
      data?.forEach((eachResult) => {
        tempData.push(
          `${eachResult.AttorneyName},${eachResult.CaseNumber},${eachResult.PlaintiffList.replace(/<br \/>/g, " ")},${eachResult.Description},${eachResult.DefendantList.replace(/<br \/>/g, " ")}\n`
        );
      });
      break;
  }
  const blob = new Blob(tempData, { type: "text/csv;charset=utf-8" });
  saveAs(blob, "file.csv");
};
